import React, { useEffect, useState } from 'react';
import { AnimateKeyframes } from 'react-simple-animate';

import { IQueueItemModel } from '../stores/models/QueueItemModel';

interface VinylDiscCoverProps {
    isPlaying: boolean;
    currentTrack?: IQueueItemModel;
}
const VinylDiscCover: React.FC<VinylDiscCoverProps> = ({ isPlaying, currentTrack }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const imageUrl = currentTrack ? currentTrack.track.imageUrl : '';

    useEffect(() => {
        // TODO: find a way to create a smooth transition on image changes
        setImageLoaded(false);
    }, [imageUrl]);

    return (
        <AnimateKeyframes
            pause={!isPlaying}
            duration={300}
            keyframes={['transform: rotate(0deg)', 'transform: rotate(360deg)']}
            iterationCount="infinite"
        >
            <figure>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <defs>
                        <mask id="shape-mask">
                            <circle id="outer" cx="50" cy="50" r="50" fill="white" />
                            <circle id="inner" cx="50" cy="50" r="20" fillOpacity="0.4" fill="black" />
                            <circle id="inner" cx="50" cy="50" r="5" fill="black" />
                        </mask>
                    </defs>
                    <rect mask="url(#shape-mask)" x="0" y="0" width="100%" height="100%" fill="black" fillOpacity=".9" />
                    {currentTrack && (
                        <image
                            width="100%"
                            height="100%"
                            opacity={imageLoaded ? 1 : 0}
                            style={{ transition: 'all .3s ease', opacity: `${imageLoaded ? 1 : 0}` }}
                            preserveAspectRatio="xMidYMid slice"
                            onLoad={() => setImageLoaded(true)}
                            href={currentTrack.track.imageUrl}
                            mask="url(#shape-mask)"
                        >
                            <animate attributeName="href" values="" dur=".3s" />
                        </image>
                    )}
                </svg>
            </figure>
        </AnimateKeyframes>
    );
};

export default VinylDiscCover;
